// extracted by mini-css-extract-plugin
module.exports = {"root":"OhBadge_root__Rk9ZW","secondary":"OhBadge_secondary__m8boa","tertiary":"OhBadge_tertiary___035Z"};